import BackButton from '../../components/BackButton'
import Alarm from './components/AlarmComponent'
import DataCompleteness from './components/DataCompleteness'
import DataQuality from './components/ThirtyDaysTrend'
import LanguageStrings from '../../i18n/locales'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { type DeviceListState } from './redux/deviceListSlice'
import { type RootState } from '../../store'
import { connect, useDispatch } from 'react-redux'
import { fetchDeviceList, fetchThirtyDayData, fetchTopIssuesData } from './redux/actionCreators'
import { useAuth } from 'react-oidc-context'
import { Grid } from '@mui/material'
import { Button } from '../../components/Button'
import { type thirtyDayState } from './redux/thirtyDaySlice'
import { changeGrandParentBreadcrumb, grandParentBreadcrumbState } from '../dashboard/redux/grandParentBreadcrumbSlice'
import { type AlarmDataState } from './redux/allAlarmsSlice'
// import KpiItem from './components/DemoKpiItem'
// import demoData from '../../demo.json'

const AmiMeterCollection = (props: any): JSX.Element => {
  const AMIMeterCollectionStrings = LanguageStrings().AMIDataCollectionStrings.LandingPage
  const DeviceDetailsStrings = LanguageStrings().DeviceDetailsStrings
  const [alignment, setAlignment] = React.useState<string | null>('list')
  const dispatch = useDispatch()
  const compQuaRef = useRef<any>(null)
  const auth = useAuth()
  const navigate = useNavigate()
  const [height, setHeight] = useState(0)
  const [screenSize, setScreenSize] = useState(window.innerWidth)
  const [colSize1, setColSize1] = useState<any>(5)
  const [colSize2, setColSize2] = useState<any>(7)

  useEffect(() => {
    setScreenSize(window.innerWidth)
    setColSize1(screenSize >= 1368 ? 5 : 6)
    setColSize2(screenSize >= 1368 ? 7 : 6)
    if (compQuaRef.current !== undefined) {
      setHeight(compQuaRef.current.clientHeight)
    }
  }, [screenSize, height, props.deviceList, props.thirtyDay, props.allActiveIssues, alignment])

  useEffect(() => {
    props.fetchDeviceList(0, 10, 'asc', 'id', auth.user?.profile.customer as string)
    props.fetchTopIssues(auth.user?.profile.customer as string)
  }, [])
  // const renderDemo = (): any => {
  //   return demoData.reports.map((report) => {
  //     return (
  //         <Grid key={report.name} item xs={4}>
  //           <KpiItem reportData={report} history={false} />
  //         </Grid>
  //     )
  //   })
  // }

  return (
        <div>
            <div className='topUtilityBar'>
                <BackButton/>
                <span id='componentTitle'>{DeviceDetailsStrings.Overview.HON_HEADINGS}</span>
                <span id='totalDevicesTitle'>{AMIMeterCollectionStrings.Total} <span>{props.deviceList.deviceCount}</span> {AMIMeterCollectionStrings.Devices}</span>
                <span id='top-right-ami-utilities'>
                  <span id='top-right-btn-span'>
                    <Button id='top-right-ami-btn' className='deviceList' sx={{ margin: 0 }} width='fit-content' onClick={() => {
                      navigate('/asset-list')
                      dispatch(changeGrandParentBreadcrumb(grandParentBreadcrumbState.honHeading))
                    }} dataTestId='create-config-btn'>{AMIMeterCollectionStrings.List}</Button>
                  </span>
                </span>
            </div>
            <Grid container spacing={2}>
                <Grid item xs={colSize1} id='data-comp-qua-column'>
                    <div ref={compQuaRef}>
                        <DataCompleteness/>
                        <br />
                        <DataQuality thirtyDay={props.thirtyDay} fethThirtyDayData={props.fetchThirtyDayData} tenant={auth.user?.profile.customer as string}/>
                    </div>
                </Grid>
                <Grid item xs={colSize2}>
                    <Alarm height={height} markers={props.allActiveIssues} alignmentObj={[alignment, setAlignment]}/>
                </Grid>
            </Grid>
            {/* Uncomment this below code to have live DashBoard  */}
            {/* <br />
            <Grid container spacing={2}>
                {renderDemo()}
            </Grid>
            <br /> */}
        </div>
  )
}

interface DispatchToProps {
  fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => void
  fetchTopIssues: (tenant: string) => void
  fetchThirtyDayData: (tenantId: string, from: string, to: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => dispatch(fetchDeviceList(page, size, sortdir, sortfield, tenantId)),
  fetchTopIssues: (tenant: string) => dispatch(fetchTopIssuesData(tenant)),
  fetchThirtyDayData: (tenantId: string, from: string, to: string) => dispatch(fetchThirtyDayData(tenantId, from, to))
})
interface StateToProps {
  deviceList: DeviceListState
  // eslint-disable-next-line @typescript-eslint/ban-types
  thirtyDay: thirtyDayState
  allActiveIssues: AlarmDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  deviceList: state.deviceList,
  thirtyDay: state.thirtyDay,
  allActiveIssues: state.allActiveIssues
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(AmiMeterCollection)
